module.exports = __webpack_public_path__ + "static/media/notes.9274abc8.png";